import { render, staticRenderFns } from "./WorkerProfilePermSummary.vue?vue&type=template&id=eb593faa&scoped=true&"
import script from "./WorkerProfilePermSummary.vue?vue&type=script&lang=ts&"
export * from "./WorkerProfilePermSummary.vue?vue&type=script&lang=ts&"
import style0 from "./WorkerProfilePermSummary.vue?vue&type=style&index=0&id=eb593faa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb593faa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VChip,VCol,VContainer,VDivider,VRow,VSpacer,VToolbar,VToolbarTitle})
